import { useEffect } from 'react';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';

const useBlockNavigation = isSaving => {
  const history = useHistory();

  useEffect(() => {
    const handleBlockNavigation = () => {
      if (isSaving) {
        const confirmLeave = window.confirm(
          'このページから離れますか？\n行った変更が保存されない可能性があります。',
        );
        if (!confirmLeave) {
          return false;
        }
      }
      return true;
    };

    const handleBeforeUnload = e => {
      if (isSaving) {
        e.preventDefault();
        e.returnValue = '';
      }
    };

    const unblock = history.block(handleBlockNavigation);

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      unblock();
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSaving, history.block]);
};

export default useBlockNavigation;
